module.exports = __webpack_public_path__ + "b1c4b4d0a9e437549a7e98726ab0723b.svg";